var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"profilePage"}},[_c('div',{staticClass:"profile-content",attrs:{"id":"profile-page"}},[_c('div',{staticClass:"sub-menu-wrapper"},[_c('SubMenu',{attrs:{"items":_vm.MenuOptions.contexts.clientArea.items}})],1),_vm._v(" "),_c('ClientArea',{key:_vm.clientAreaKey})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }